import React                from 'react';
import { Container, Item }  from './components';

export class Skeleton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    createComponentClasses() {
        const {
            className,
            bordered,
            vertical,
        } = this.props;

        let classNames = ['marketkit-skeleton'];
        if (bordered)       classNames.push('bordered');
        if (vertical)       classNames.push('vertical');
        if (className)      Array.prototype.push.apply(classNames, className.split(' '));

        return [ ...new Set(classNames) ].join(' ');
    }

    getSizeValues() {
        const p = this.props;
        const width = p.width
                        ? p.percentage
                            ? `calc(${p.width}% - 10px)`
                            : `calc(${p.width}px - 10px)`
                        : `calc(100% - 10px)`;
        const height = p.height || 10;
        return {
            width: width,
            height: height
        }
    }

    createItems(){
        const p = this.props;
        const count = p.count || 1;
        let items = [];
        let sizes = this.getSizeValues()
        for(let i = 0; i< count; i++) {
            items.push(
                <Item 
                    key       = { i }
                    className = { p.className }
                    width     = { sizes.width }
                    height    = { sizes.height }
                />
            )
        }
        return items;
    } 

    createBaseComponent() {
        const p = this.props;
        return (
            p.children
                ?   <Container 
                        className   = { this.createComponentClasses() }
                        width       = { p.width }
                        height      = { p.height }
                    >
                        { p.children }
                    </Container>
                :   this.createItems()
        )
    }

    render() { 
        return (
            this.createBaseComponent()
        );
    }
}

export default Skeleton;